export const SITE = {
  tw: {
    path: '/tw',
    site: 'tw',
    languages: ['zh', 'zh-tw', 'zh_tw'],
    defaultLang: 'zh-tw'
  },
  en: {
    path: '/en',
    site: 'en',
    languages: ['en', 'en-us', 'en_us'],
    defaultLang: 'en'
  },
  jp: {
    path: '/jp',
    site: 'jp',
    languages: ['ja', 'ja-jp', 'ja_jp'],
    defaultLang: 'ja'
  },
  kr: {
    path: '/kr',
    site: 'kr',
    languages: ['ko', 'ko-kr', 'ko_kr'],
    defaultLang: 'ko'
  },
  cn: {
    path: '/cn',
    site: 'cn',
    languages: ['zh-cn', 'zh_cn', 'zh-hans', 'zh-hans-cn'],
    defaultLang: 'zh-cn'
  },
  hk: {
    path: '/hk',
    site: 'hk',
    languages: ['zh_hk', 'zh-hk'],
    defaultLang: 'zh-tw' // fallback to zh-tw language file
  }
};
